/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Humiditymaxsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Maximum humidity setpoint" |
*
* @param {Ahu_History_Key_Humiditymaxsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_humiditymaxsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Humiditymaxsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Humiditymaxsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne maximum d'hygrométrie")
});
export { ahu_history_key_humiditymaxsetpoint2 as "ahu_history_key_humidityMaxSetpoint" }